import { helmTokens } from '../../theme';
import { css } from '@sail/ui';
export const styles = {
    logo: css({
        color: `${helmTokens.color.navColor}`,
        display: 'block'
    })
};

//# sourceMappingURL=StripeLogoStyles.js.map